import { Link } from 'react-router-dom';
import { categories } from '@/mocks/chigua';

const explore = [
  { to: '/hot', label: '今日瓜点热榜' },
  { to: '/hot', label: '围观指南' },
  { to: '/about', label: '关于我们' },
];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-950 text-primary-50">
      <div className="container-x grid grid-cols-1 gap-10 py-12 md:grid-cols-4 md:py-16">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center gap-2" aria-label="吃瓜路线 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-400 text-primary-950">
              <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl text-primary-50">吃瓜路线</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-6 text-primary-200/80">
            聚焦微博、抖音、贴吧的热门讨论焦点，为你整理最清晰的围观指南与吃瓜路线，不错过每一颗新鲜热瓜。
          </p>
          <p className="mt-4 text-sm text-primary-200/70">品牌口号 · 不迷路，只吃瓜</p>
        </div>

        <div>
          <h3 className="font-heading text-base text-primary-50">快速浏览</h3>
          <ul className="mt-4 space-y-3">
            {explore.map((item) => (
              <li key={item.label}>
                <Link to={item.to} className="inline-flex items-center gap-2 text-sm text-primary-200/80 transition-colors hover:text-primary-50">
                  <i className="ri-arrow-right-s-line text-primary-300" aria-hidden="true"></i>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-base text-primary-50">围观栏目</h3>
          <div className="mt-4 flex flex-wrap gap-2">
            {categories.slice(1).map((c) => (
              <Link
                key={c.key}
                to={`/hot?cat=${c.key}`}
                className="rounded-full border border-primary-700/60 px-3 py-1.5 text-xs text-primary-200/85 transition-colors hover:border-primary-400 hover:bg-primary-800 hover:text-primary-50"
              >
                {c.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-heading text-base text-primary-50">保持联系</h3>
          <ul className="mt-4 space-y-3 text-sm text-primary-200/80">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-300" aria-hidden="true"></i>
              hello@chigualuxian.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-300" aria-hidden="true"></i>
              每日更新 · 全平台聚焦
            </li>
          </ul>
          <div className="mt-5 flex items-center gap-2">
            {['ri-weibo-line', 'ri-vidicon-line', 'ri-chat-smile-3-line', 'ri-rss-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                aria-label="社交平台入口"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-primary-600 hover:text-primary-50"
              >
                <i className={`${icon} text-base`} aria-hidden="true"></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800/70">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-primary-200/60 sm:flex-row">
          <p>© {new Date().getFullYear()} 吃瓜路线 · 仅供信息整理与交流参考</p>
          <p className="flex items-center gap-1">
            <i className="ri-focus-3-line text-primary-300" aria-hidden="true"></i>
            不迷路，只吃瓜
          </p>
        </div>
      </div>
    </footer>
  );
}